import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ComponentBase, IntegrationLogInfo, IntegrationLogType } from 't4core';
import { start } from 'repl';
import { T4DatatableWidget } from '../../../../t4common';

@Component({
    selector: 't4-integration-logs',
  templateUrl: './IntegrationLogs.html',
  styleUrls: ['./IntegrationLogs.css']
})

export class IntegrationLogs extends ComponentBase implements OnInit {
  public isLoading: boolean = false;
  @ViewChild("tblIntegrationLogs", { static: false }) tblIntegrationLogs: T4DatatableWidget;
  public IntegrationLogsData: IntegrationLogInfo[] = [];
  @Input() entityId: string = "";
  @Input() type: IntegrationLogType = undefined;  
  
  constructor() {
    super();
  }

  public async ngOnInit() {
    await this.loadData();
  }

  private async loadData() {
    this.isLoading = true;
    if (this.entityId != "" && this.type != undefined) {
      this.IntegrationLogsData = await this.Api.get<IntegrationLogInfo[]>("/TurboOrder/GetIntegrationLogs", { type: this.type, entityId: this.entityId });
    }
    else if (this.type != undefined) {
      this.IntegrationLogsData = await this.Api.get<IntegrationLogInfo[]>("/TurboOrder/GetIntegrationLogs", { type: this.type });
    }
    this.isLoading = false;
  }

  public async RefreshData() {
    await this.loadData();
    this.UI.alert("TO.EntityLogs.RefreshDataPopup", "Refresh completed", "TO.EntityLogs.msgRefreshDataPopup1", "The integration logs are updated from database.")
  }

}
